module.exports = __webpack_public_path__ + "img/Inflammation-OSCC_GSE208253.0d543638.png";